import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=74e5a19e&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74e5a19e')) {
      api.createRecord('74e5a19e', component.options)
    } else {
      api.reload('74e5a19e', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=74e5a19e&", function () {
      api.rerender('74e5a19e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Yr1tWhLzAUSZ/JS/comp/FavElement.vue"
export default component.exports